import { render, staticRenderFns } from "./CsimConfigFormVisibleModal.vue?vue&type=template&id=2ddcbc57&scoped=true"
import script from "./CsimConfigFormVisibleModal.vue?vue&type=script&lang=js"
export * from "./CsimConfigFormVisibleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddcbc57",
  null
  
)

export default component.exports